import { MutableRefObject, useCallback, useEffect } from 'react'

type ElementRef = MutableRefObject<HTMLElement | null>

interface Props {
  elementRef?: ElementRef | ElementRef[]
  clickOutsideFunction?: () => void
}

export const useClickOutside = ({
  elementRef,
  clickOutsideFunction = () => null,
}: Props) => {
  const arrayContainValidElements = (array: ElementRef[]) =>
    array.every(element => element?.current)

  const handleList = useCallback(
    (target: HTMLElement, array: ElementRef[]) => {
      const elementsThatDoNotContainTarget = array.filter(
        el => !el?.current?.contains(target)
      )

      if (
        elementsThatDoNotContainTarget &&
        elementsThatDoNotContainTarget.length === array.length
      ) {
        return clickOutsideFunction()
      }
      return null
    },
    [clickOutsideFunction]
  )

  const handleSingleElement = useCallback(
    (target: HTMLElement, element: HTMLElement) => {
      if (!element?.contains(target)) return clickOutsideFunction()
      return null
    },
    [clickOutsideFunction]
  )

  useEffect(() => {
    const container = document.getElementById('app')
    const handleCloseSelectOptions = ({ target }: Event) => {
      if (!elementRef || !target) return null

      const clickedEl = target as HTMLElement
      if (Array.isArray(elementRef)) return handleList(clickedEl, elementRef)
      return handleSingleElement(clickedEl, elementRef.current as HTMLElement)
    }

    if (
      elementRef &&
      ((Array.isArray(elementRef) && arrayContainValidElements(elementRef)) ||
        (!Array.isArray(elementRef) && elementRef.current))
    ) {
      container?.addEventListener('click', handleCloseSelectOptions, false)
    }

    return () => {
      container?.removeEventListener('click', handleCloseSelectOptions, false)
    }
  }, [elementRef, handleList, handleSingleElement])
}
